import {
  alpha,
  Avatar,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  LinearProgress,
  Link,
  styled,
  Typography,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'
import OAuthProviderButton from '../LoginStepper/oauth/OAuthProviderButton'

const TEXT_ACTION_STYLES = {
  alignSelf: 'flex-start',
  minHeight: 44,
  fontWeight: 600,
} as const

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    margin: theme.spacing(2),
    width: 'calc(100% - 32px)',
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(4),
      width: 'calc(100% - 64px)',
    },
  },
}))

export const BusyProgress = styled(LinearProgress)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
})

export const StepContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(1.5, 2.25, 1),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}))

// Stacked on phones, with the main action on top
export const StepActions = styled(DialogActions)(({ theme }) => ({
  flexDirection: 'column-reverse',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2.25, 3),
  '& .MuiButton-root': { minHeight: 44 },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}))

export const StatusChip = styled(Chip)(({ theme }) => ({
  borderRadius: 10,
  fontWeight: 600,
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  '& .MuiChip-icon': {
    color: 'inherit',
  },
}))

export const StepBar = styled('span', {
  shouldForwardProp: prop => prop !== 'isDone',
})<{ isDone: boolean }>(({ theme, isDone }) => ({
  width: 20,
  height: 4,
  borderRadius: 2,
  backgroundColor: isDone
    ? theme.palette.primary.main
    : alpha(theme.palette.primary.main, 0.2),
}))

export const SectionTitle = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(0, 0, 2),
  paddingBottom: theme.spacing(1.25),
  fontSize: 14,
  fontWeight: 600,
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const TextActionButton = styled(LoadingButton)({
  ...TEXT_ACTION_STYLES,
  textTransform: 'none',
})

// Cast, as styled() drops the type of the component prop
export const TextActionLink = styled(Link)(TEXT_ACTION_STYLES) as typeof Link

export const ProminentOAuthProviderButton = styled(OAuthProviderButton)({
  minHeight: 52,
  fontSize: 15,
  fontWeight: 600,
  textTransform: 'none',
})

export const AccountCardWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5, 1.75),
  borderRadius: 12,
  backgroundColor: alpha(theme.palette.primary.main, 0.06),
}))

export const AccountAvatar = styled(Avatar)(({ theme }) => ({
  width: 32,
  height: 32,
  fontSize: 12,
  fontWeight: 700,
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.paper,
}))

export const ProviderChip = styled(Chip)(({ theme }) => ({
  borderRadius: 10,
  fontWeight: 600,
  backgroundColor: theme.palette.background.paper,
}))
